import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { IdParts } from "../@types";
import routes from "../app/routes";
import { makePlanLongId } from "../helpers";

interface PlanDetailsLinkProps extends RouteComponentProps {
  ariaDescribedBy?: string;
  ariaLabelledBy?: string;
  className?: string;
  htmlId?: string;
  label: React.ReactNode;
  onClick?: () => void;
  plan: IdParts;
  section?: string;
}

const PlanDetailsLink: React.FunctionComponent<PlanDetailsLinkProps> = ({
  ariaDescribedBy,
  ariaLabelledBy,
  className,
  htmlId,
  label,
  location,
  onClick,
  plan,
  section,
}) => {
  return (
    <Link
      {...(ariaDescribedBy ? { "aria-describedby": ariaDescribedBy } : {})}
      {...(ariaLabelledBy ? { "aria-labelledby": ariaLabelledBy } : {})}
      className={className || ""}
      id={htmlId || ""}
      onClick={onClick}
      to={`${routes.planDetails.replace(":id", makePlanLongId(plan))}${
        location.search
      }${section ? `#${section}` : ""}`}
    >
      {label}
    </Link>
  );
};

export default withRouter(PlanDetailsLink);
